// extracted by mini-css-extract-plugin
export default {"title":"register_title__hlc3j","name":"register_name__D+pCB","email":"register_email__9cQjm","password":"register_password__ReVFR","termsOfUseText":"register_termsOfUseText__9Zfei"};